<div class="filter-section" [class.embedded]="embedded" [class.nova-open-upward]="openUpward">
  <filter-button *ngIf="!embedded" [buttonTitle]="buttonTitle" [_dropdownOpened]="_dropdownOpened()"
    (onButtonClick)="toggleDropdown()"></filter-button>

  <div class="dropdown-content-container" [ngClass]="{ center: !filterData.length }"
    *ngIf="_dropdownOpened()"
    appOutSideClick
    (outSideClick)="onOutsideClick()">
    <div class="table-filter-dropdown">
      <div class="filter-selectors">
        <table-filter></table-filter>
        <saved-concepts
          (conceptSelected)="onSavedConceptSelected($event)"
          (dropdownToggled)="onSavedConceptsDropdownToggled($event)"
        ></saved-concepts>
      </div>
      <filter-save-dropdown (clearFilters)="handleClearFilters()"
        (onSaveFilters)="getFilterList()"></filter-save-dropdown>
    </div>
    <hr class="full-width-hr">
    <div class="container-header">
      <div class="filter-list" *ngIf="filterData.length; else emptyLabel">

        <div class="show_title">
          <span class="show-header-title">{{dropdown.show_records}}</span>
        </div>
        <div cdkDropList [cdkDropListData]="filterData" (cdkDropListDropped)="drop($event)" class="item-wrapper">
          <div *ngFor="let item of filterData; index as i" cdkDrag
            [ngClass]="{ 'cluster-space': i > 0 && filterData[i - 1].clusterData}">
            <filter-item *ngIf="!item.isCluster" [filterItem]="item" [openAbove]="i > 3"
              [filterItems]="filterData"></filter-item>
            <filter-cluster *ngIf="item.isCluster" [filterItem]="item" [openAbove]="i > 3" [filterItems]="filterData">
            </filter-cluster>
          </div>
        </div>
      </div>

      <div class="add-condition-container">
        <!--add condition button--->
        <button class="custom-add-button" (click)="handleAddCondition()">
          <div class="button-content-add">
            <img src="assets/icons/add.svg" alt="Add" class="button-icon" />
            <span class="button-text">{{ dropdown.add_condition }}</span>
          </div>
        </button>
        <button class="custom-add-button concept-filter-btn" type="button" (click)="openConceptFilterDialog()">
          <div class="button-content-add">
            <img src="assets/icons/add.svg" alt="Concept filter" class="button-icon" />
            <span class="button-text">{{ dropdown.concept_filter || 'Concept filter' }}</span>
          </div>
        </button>
      </div>

      <ng-template #emptyLabel>
        <div class="header-title">{{ dropdown.no_filter_conditions_applied }}</div>
      </ng-template>
    </div>


    <div class="button-container" [ngClass]="{ center: !filterData.length }">
      <div class="add-button-wrapper">
        <ng-template #removeFilter>
          <app-button [buttonText]="dropdown.clear_filters" (onButtonClick)="handleClearFilters()"
            [backgroundColor]="'#EBEFF5'" [Color]="'#475258'">
          </app-button>
        </ng-template>
      </div>

      <div class="filter-button-section" *ngIf="filterData.length" (click)="handleClearFilters()">
        <div class="clear-condition-text">Clear Conditions</div>
        <div class="add-button-wrapper">
          <app-button [buttonText]="dropdown.apply_filters" (onButtonClick)="handleApplyFilters()"
            [backgroundColor]="applyButtonActive ? '#534AD8' : '#BFCCD9'" [Color]="'#FFFFFF'">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
